module.exports = __webpack_public_path__ + "img/wtch.9488cca5.jpg";